// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'


import Vant from 'vant';
import 'vant/lib/index.css';


import './plugins/axios'
import api from './plugins/api'

Vue.config.productionTip = false
Vue.use(Vant);

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})



Vue.prototype.$api = api

/* eslint-disable no-new */
var vue=new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
export default vue



// WEBPACK FOOTER //
// ./src/main.js